export default function kycApi(fetch, baseUrl) {
  return {
    getKycDetailsAndDocs({
      userId,
      payload
    }) {
      return fetch.post(`${baseUrl}/kyc/${userId}/v2`, payload);
    },

    userKycStatus({ userId, pageNo = 0, pageSize = 10 }) {
      return fetch(
        `${baseUrl}/uae-duplicate-user/associated-user-ids/${userId}?page=${pageNo}&page_size=${pageSize}`
      );
    },

    userKycStatusSumsub({ userId }) {
      return fetch(
        `/admin/kyc/${userId}/sumsub-duplicate-users`
      );
    },

    checks({ pageNo = 0, pageSize = 10, userId }) {
      return fetch(
        `${baseUrl}/user/${userId}/kyc/checks?&page=${pageNo}&page_size=${pageSize}`
      );
    },

    updateKycStatus(formData, userId) {
      return fetch.put(
        `${baseUrl}/user/${userId}/v2/kyc/details`,
        // `${baseUrl}/user/${userId}/kyc/details`,
        Object.keys(formData).reduce((prev, curr) => {
          if (!formData[curr]) return prev;
          return {
            ...prev,
            [curr]: formData[curr]
          };
        }, {})
      );
    },

    updateKycStatusV2(userId, formData) {
      return fetch.put(
        `${baseUrl}/user/${userId}/kyc/kyc-detail`,
        formData
      );
    },

    syncUserKyc({ userId, product, provider, subProvider }) {
      return fetch.get(
        `${baseUrl}/user/${userId}/kyc/sync?product=${product}&provider=${provider}&sub_provider=${subProvider}`
      );
    },

    syncVanceUserKyc({ userId, product }) {
      return fetch.post(`${baseUrl}/vance-user-kyc/${userId}/${product}/sync`);
    },

    getKycFile(url, userId) {
      return fetch.get(`${baseUrl}/user/${userId}/kyc/docs/${url}`);
    },

    allKycs({
      userId,
      provider,
      product,
      status,
      pageNo,
      pageSize,
      query,
      country
    }) {
      return fetch.get(
        `${baseUrl}/kyc?provider=${provider}&product=${product}&${
          status?.length ? `&status=${status}` : ''
        }&page=${pageNo}&page_size=${pageSize}&country=${country}${
          query?.length ? `&query=${query}` : ''
        }${userId?.length ? `&user_id=${userId}` : ''}
        `
      );
    },

    allKycsV2(requestBody) {
      return fetch.post(`${baseUrl}/kyc/search`, requestBody);
    },
    
    updateCheckStatus({ checkId }) {
      return fetch.put(`${baseUrl}/kyc/checks/${checkId}`);
    },

    createEKyc({ userId }) {
      return fetch.post(`${baseUrl}/user/${userId}/kyc/e-kyc`);
    },

    createMKyc({ userId }) {
      return fetch.post(`${baseUrl}/user/${userId}/kyc/m-kyc`);
    },

    rejectEfrKyc({ userId, data }) {
      return fetch.put(`${baseUrl}/reject-efr-kyc/${userId}`, data);
    },

    rejectEfr({ userId }) {
      return fetch.post(`${baseUrl}/vance-user-kyc/${userId}/efr/reject`);
    },

    kycTags() {
      return fetch(`${baseUrl}/tags`);
    },

    getUserTiers({ userId }) {
      return fetch.get(`${baseUrl}/kyc/${userId}/get-tiers`);
    },

    blockUser({ userId, product, provider, subProvider }) {
      return fetch.put(
        `${baseUrl}/user/${userId}/kyc/block?product=${product}&provider=${provider}&subProvider=${subProvider}`
      );
    }
  };
}
